import { multiply as _multiply, screen as _screen } from 'color-blend';
import parseColor from 'parse-color';
export function multiply(bg, fg) {
  var _a = parseColor(bg).rgb;
  var _b = parseColor(fg).rgb;

  var _multiply2 = _multiply({
    r: _a[0],
    g: _a[1],
    b: _a[2],
    a: 1
  }, {
    r: _b[0],
    g: _b[1],
    b: _b[2],
    a: 1
  }),
      r = _multiply2.r,
      g = _multiply2.g,
      b = _multiply2.b;

  return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
}
export function screen(bg, fg) {
  var _a = parseColor(bg).rgb;
  var _b = parseColor(fg).rgb;

  var _screen2 = _screen({
    r: _a[0],
    g: _a[1],
    b: _a[2],
    a: 1
  }, {
    r: _b[0],
    g: _b[1],
    b: _b[2],
    a: 1
  }),
      r = _screen2.r,
      g = _screen2.g,
      b = _screen2.b;

  return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
}